export default __webpack_public_path__ + "static/media/heroBackground.77fdfdb4.png";